{
  "dashboard": {
    "headTitle": "Дашборд биллинга",
    "title": "Дашборд биллинга",
    "scopeTitleGlobal": "Дашборд: вся платформа",
    "scopeTitleCompany": "Дашборд: {{name}}",
    "scopeGlobal": "Вся платформа",
    "scopeSwitcherAria": "Выбор скоупа дашборда",
    "projectSwitcherAria": "Выбор проекта",
    "subtitle": "Затраты и сжигание токенов по платформе.",
    "companyHeadTitle": "{{name}} · Биллинг",
    "companySubtitle": "Использование этой компании.",
    "projectHeadTitle": "{{name}} · Биллинг",
    "projectSubtitle": "Использование внутри проекта.",
    "openJournal": "Открыть журнал",
    "period24h": "24 часа",
    "period7d": "7 дней",
    "period30d": "30 дней",
    "period90d": "90 дней",
    "periodMonth": "Текущий месяц",
    "periodAll": "Все время",
    "periodApply": "Применить",
    "allStatuses": "Все статусы",
    "currency": "Валюта выручки",
    "searchPlaceholder": "Поиск",
    "noResults": "Ничего не найдено",
    "kpi": {
      "cost": "Себестоимость",
      "revenue": "Выручка",
      "units": "Единицы",
      "tokens": "Токены",
      "chars": "Символы",
      "duration": "Длительность",
      "videoDuration": "Видео",
      "audioDuration": "Аудио",
      "images": "Изображения",
      "generations": "Генерации",
      "failedRate": "ошибки",
      "unrated": "Без тарифа",
      "unratedHint": "Успешные генерации в биллуемых медиа без начисленной выручки — нет тарифа или рейтинг упал",
      "avgCost": "Средняя / ген.",
      "avgPerGen": "средняя / ген.",
      "deltaVsPrev": "К предыдущему периоду той же длины",
      "effectiveRate": "выручка на $1 себестоимости",
      "effectiveRateHint": "Эффективная монетизация за период: сколько выручки в валюте дашборда принёс каждый доллар затрат на провайдеров",
      "billedDuration": "Биллинг. длительность",
      "promptTokens": "вход",
      "completionTokens": "выход"
    },
    "series": {
      "title": "Динамика",
      "metricRevenue": "Выручка",
      "metricCost": "Себестоимость",
      "metricTokens": "Токены",
      "metricCount": "Кол-во",
      "stackMedia": "По медиа",
      "stackProvider": "По провайдеру",
      "modeArea": "Area",
      "modeBar": "Bar",
      "empty": "Нет данных за период"
    },
    "share": {
      "title": "Доля стоимости",
      "titleRevenue": "Структура выручки",
      "titleCost": "Структура себестоимости",
      "tabMedia": "Медиа",
      "tabProvider": "Провайдер"
    },
    "shareMedia": "Доля стоимости по медиа",
    "shareProvider": "Доля стоимости по провайдеру",
    "donut": {
      "empty": "Нет данных за период",
      "revenue": "Выручка",
      "cost": "Себестоимость",
      "units": "Единицы",
      "tokens": "Токены",
      "count": "Кол-во"
    },
    "units": {
      "tokens": "ток.",
      "video": "видео",
      "audio": "аудио",
      "chars": "симв.",
      "images": "изобр."
    },
    "table": {
      "name": "Название",
      "cost": "Себестоимость",
      "revenue": "Выручка",
      "revenueShare": "% выручки",
      "units": "Израсходовано",
      "video": "Видео",
      "images": "Изображения",
      "audio": "Аудио",
      "voice": "Голос",
      "text": "Текст",
      "tokens": "Токены",
      "count": "Кол-во",
      "failed": "Ошибки",
      "total": "Итого",
      "openJournal": "Открыть в журнале",
      "empty": "Нет строк",
      "other": "Прочее"
    },
    "mediaKinds": {
      "video": "Видео",
      "image": "Изображения",
      "audio": "Аудио",
      "voice": "Голос",
      "lipsync": "Липсинк",
      "text": "Текст",
      "other": "Другое",
      "unknown": "Не указан"
    },
    "breakdowns": {
      "companies": "По компаниям",
      "projects": "По проектам",
      "users": "По пользователям",
      "provider_models": "По провайдеру / модели",
      "job_kinds": "По типу job",
      "media_kinds": "По медиа",
      "episodes": "По эпизоду / сцене"
    }
  },
  "billingExports": {
    "history": "История выгрузок",
    "historyTitle": "Выгрузки",
    "queued": "Выгрузка запущена — прогресс в очереди задач.",
    "queueFailed": "Не удалось запустить выгрузку",
    "loading": "Загрузка…",
    "empty": "Выгрузок пока нет.",
    "loadFailed": "Не удалось загрузить выгрузки.",
    "download": "Скачать",
    "cancel": "Отменить",
    "cancelConfirm": "Отменить эту выгрузку?",
    "cancelFailed": "Не удалось отменить выгрузку",
    "kinds": {
      "company_operations": "Операции",
      "company_usage": "Журнал использования",
      "platform_usage": "Журнал использования",
      "promo_codes": "Промокоды",
      "promo_redemptions": "Применения",
      "promo_qr": "QR-коды",
      "promo_cards": "Визитки"
    }
  },
  "usage": {
    "headTitle": "Журнал генераций",
    "title": "Журнал генераций",
    "count": "{{count}} записей",
    "searchPlaceholder": "Поиск",
    "periodAll": "Все время",
    "period24h": "24 часа",
    "period7d": "7 дней",
    "allStatuses": "Все статусы",
    "allMediaKinds": "Все медиа",
    "allCompanies": "Все компании",
    "allProjects": "Все проекты",
    "allProviders": "Все провайдеры",
    "allUsers": "Все пользователи",
    "allModels": "Все модели",
    "allJobKinds": "Все задачи",
    "unsettled": "Не закрыт расчёт",
    "unsettledHint": "Успешные генерации с выручкой, по которым не прошло списание после включения режима биллинга. Нажмите, чтобы снять фильтр",
    "currencyHint": "Выручка в валюте среза дашборда. Нажмите, чтобы показать все валюты",
    "currencyMismatch": "Валюта ≠ валюте счёта",
    "currencyMismatchHint": "Валюта события не совпадает с валютой его счёта: списание не проводится. Нажмите, чтобы снять фильтр",
    "unrated": "Без тарифа",
    "unratedHint": "Успешные генерации, для которых не нашлось ставки: цена не посчитана, списывать нечего. Нажмите, чтобы снять фильтр",
    "export": "Экспорт в XLSX",
    "moreFilters": "Ещё фильтры",
    "exporting": "Экспорт…",
    "exportError": "Не удалось выгрузить",
    "columnsToggle": "Колонки",
    "columnsDefault": "По умолчанию",
    "columnsSelectAll": "Выбрать все",
    "empty": "Нет записей журнала по фильтру",
    "prevPage": "Назад",
    "nextPage": "Дальше",
    "pageOf": "Стр. {{page}} / {{pages}}",
    "range": "{{from}}–{{to}} из {{total}}",
    "perPage": "{{count}} / стр.",
    "status": {
      "started": "В процессе",
      "succeeded": "Успех",
      "failed": "Ошибка"
    },
    "columns": {
      "id": "ID",
      "billing_key": "Billing key",
      "started_at": "Старт",
      "finished_at": "Завершено",
      "status": "Статус",
      "tariff_code": "Тариф",
      "company_id": "Company ID",
      "company_name": "Компания",
      "project_id": "Project ID",
      "project_name": "Проект",
      "user_id": "User ID",
      "user_email": "Пользователь",
      "media_kind": "Медиа",
      "job_kind": "Задача",
      "provider": "Провайдер",
      "ai_model": "Модель",
      "model_id": "Model ID",
      "source_type": "Source type",
      "source_id": "Source ID",
      "generation_job_id": "Job ID",
      "generation_request_log_id": "Request log ID",
      "generation_model_route_id": "Model route ID",
      "season_id": "Season ID",
      "season_number": "Сезон №",
      "episode_id": "Episode ID",
      "episode_number": "Эпизод №",
      "scene_id": "Scene ID",
      "scene_number": "Сцена №",
      "shot_id": "Shot ID",
      "shot_number": "Шот №",
      "canvas_id": "Canvas ID",
      "canvas_generation_id": "Canvas gen ID",
      "character_id": "Character ID",
      "location_id": "Location ID",
      "prop_id": "Prop ID",
      "voice_id": "Voice ID",
      "medium_id": "Medium ID",
      "camera_preset_id": "Camera ID",
      "animatic_segment_id": "Animatic segment ID",
      "animatic_segment_transcription_id": "Transcription ID",
      "aspect_ratio": "Aspect ratio",
      "requested_image_size": "Image size",
      "requested_resolution": "Resolution",
      "requested_width": "Req. width",
      "requested_height": "Req. height",
      "requested_duration_sec": "Запрошенная длительность",
      "generate_audio": "Generate audio",
      "seed": "Seed",
      "use_project_styles": "Project styles",
      "reference_image_count": "Ref. images",
      "reference_video_count": "Ref. videos",
      "spoken_text_length": "Spoken length",
      "provider_voice_id": "Provider voice ID",
      "voice_provider_kind": "Voice provider",
      "sts": "STS",
      "billed_duration_sec": "Фактическая длительность",
      "billed_width": "Billed width",
      "billed_height": "Billed height",
      "prompt_tokens": "Prompt tokens",
      "completion_tokens": "Completion tokens",
      "total_tokens": "Токены",
      "native_tokens_completion": "Native tokens",
      "estimated_cost_microcents": "Себестоимость",
      "cost_microcents": "Себестоимость (факт)",
      "billed_units": "Ед. биллинга",
      "tariff_unit": "Единица тарифа",
      "tariff_base_unit_price_microcents": "Базовая цена за единицу",
      "tariff_discount_percent": "Скидка ставки",
      "tariff_unit_price_microcents": "Цена за единицу",
      "pre_plan_revenue_microcents": "Выручка до плана",
      "plan_code": "План",
      "plan_discount_percent": "Скидка плана (%)",
      "plan_discount_amount_microcents": "Скидка плана",
      "promotion_code": "Акция",
      "promotion_discount_percent": "Скидка акции (%)",
      "promotion_discount_amount_microcents": "Скидка акции",
      "revenue_microcents": "Выручка",
      "currency": "Валюта",
      "settled_amount_microcents": "Списано",
      "settled_at": "Списано (когда)",
      "rated_at": "Тарифицировано",
      "rating_error": "Ошибка тарификации",
      "billing_tariff_rate_id": "Tariff rate ID",
      "billing_cost_rate_id": "Cost rate ID",
      "error_message": "Ошибка",
      "settings_json": "settings_json",
      "usage_json": "usage_json",
      "created_at": "Создано",
      "updated_at": "Обновлено"
    },
    "yes": "Да",
    "no": "Нет",
    "detail": {
      "title": "Запись журнала",
      "close": "Закрыть",
      "overview": "Обзор",
      "billingKey": "Ключ биллинга",
      "tariff": "Тариф",
      "modelId": "ID модели",
      "source": "Источник",
      "hierarchy": "Иерархия",
      "entities": "Сущности",
      "request": "Запрос",
      "billed": "Биллинг",
      "error": "Ошибка",
      "settingsJson": "settings_json",
      "usageJson": "usage_json",
      "finishedAt": "Завершено",
      "createdAt": "Создано",
      "size": "Размер",
      "promptTokens": "Prompt tokens",
      "completionTokens": "Completion tokens",
      "totalTokens": "Total tokens",
      "nativeTokens": "Native completion tokens",
      "refs": "Референсы",
      "seed": "Seed",
      "generateAudio": "Generate audio",
      "sts": "STS",
      "spokenLength": "Длина spoken text",
      "voice": "Голос",
      "aspect": "Соотношение сторон",
      "resolution": "Разрешение",
      "refsValue": "img {{img}} · vid {{vid}}",
      "rating": "Тарификация",
      "billedUnits": "Ед. биллинга",
      "unitPrice": "Цена за единицу",
      "revenue": "Выручка",
      "estimatedCost": "Себестоимость (расчёт)",
      "providerCost": "Себестоимость (факт)",
      "ratedAt": "Тарифицировано",
      "ratingError": "Ошибка тарификации",
      "loading": "Загрузка деталей…",
      "loadError": "Не удалось загрузить детали",
      "cascade": "Финансовый каскад",
      "basePrice": "Базовая цена за единицу",
      "rateDiscount": "Скидка ставки",
      "discountedUnitPrice": "Цена со скидкой ставки",
      "prePlanRevenue": "Выручка до плана",
      "plan": "План",
      "planDiscountAmount": "Скидка плана",
      "promotion": "Акция",
      "promotionDiscountAmount": "Скидка акции",
      "finalRevenue": "Финальная выручка",
      "settled": "Списано",
      "settledAt": "Списано (когда)",
      "statementLink": "Выписка счёта"
    },
    "client": {
      "columns": {
        "revenue_microcents": "Стоимость",
        "pre_plan_revenue_microcents": "Стоимость до скидки"
      },
      "detail": {
        "revenue": "Стоимость",
        "prePlanRevenue": "Стоимость до скидки",
        "finalRevenue": "Итого"
      }
    }
  },
  "rates": {
    "costRatesTitle": "Себестоимость",
    "costRatesSubtitle": "Закупочная цена по моделям — только новые версии",
    "priceListTitle": "Глобальный прайс-лист",
    "priceListSubtitle": "Тарифы продажи: секунды видео и картинки",
    "companyPriceListTitle": "Тарифы компании",
    "companyPriceListSubtitle": "Переопределения для {{name}} — иначе действует GPL",
    "addRate": "Добавить ставку",
    "addTariff": "Добавить тариф",
    "edit": "Изменить",
    "override": "Переопределить",
    "cancelPending": "Отменить pending",
    "cancelPendingConfirm": "Отменить pending-версию? Предыдущая открытая версия будет восстановлена.",
    "effectiveRange": "{{from}} – {{till}}",
    "openEnded": "открыта",
    "overriddenTooltip": "GPL: {{price}}",
    "companyScopeTitle": "Тарифы: {{name}}",
    "scopeGlobal": "Глобальный (GPL)",
    "priceLists": {
      "select": "Прайс-лист",
      "create": "Новый прайс-лист",
      "createTitle": "Новый прайс-лист",
      "archive": "В архив",
      "archiveConfirm": "Архивировать прайс-лист «{{name}}»? Тарифы останутся в истории, назначить его счёту будет нельзя.",
      "accountsCount": "счетов: {{count}}",
      "name": "Название",
      "currency": "Валюта",
      "copyFrom": "Скопировать тарифы из",
      "copyNone": "Пустой список",
      "rate": "Курс: {{from}} за 1 {{to}}",
      "copyHint": "Цены источника делятся на курс; копируется вся история версий. Для той же валюты курс — 1."
    },
    "export": {
      "button": "Скачать",
      "title": "Скачать прайс-лист",
      "priceList": "Прайс-лист",
      "date": "Цены на дату",
      "company": "Клиент",
      "companyNone": "Не указан",
      "companySearch": "Поиск компании",
      "discount": "Скидка, %",
      "kpNumber": "Номер КП",
      "kpPlaceholder": "Необязательно",
      "signature": "Подпись руководителя",
      "stamp": "Печать",
      "stampUnavailable": "Печать не загружена в реквизитах",
      "search": "Поиск модели",
      "selected": "Выбрано {{count}} из {{total}}",
      "selectAll": "Выбрать всё",
      "clearAll": "Снять всё",
      "nothingFound": "Ничего не найдено.",
      "emptyList": "В этом прайс-листе нет действующих ставок.",
      "downloadPdf": "Скачать PDF",
      "downloadXlsx": "Скачать XLSX",
      "preparing": "Готовим…",
      "failed": "Не удалось выгрузить: {{message}}"
    },
    "scopeOverrides": "переопределений: {{count}}",
    "scopeSwitcherAria": "Выбор прайс-листа",
    "rateKey": "Ключ",
    "model": "Модель",
    "unit": "Единица",
    "price": "Цена",
    "perQuantity": "Количество",
    "pricePer": "{{price}} / {{qty}} {{unit}}",
    "resolution": "Разрешение",
    "resolutionAny": "Любое",
    "variant": "Вариант",
    "discount": "Скидка",
    "discountedPrice": "Цена со скидкой",
    "mediaKind": "Медиа",
    "validFromNotice": "Изменения вступят в силу {{date}}, 00:00 GMT+3",
    "firstVersionNotice": "Первая версия действует с сегодня (GMT+3)",
    "empty": "Ставок пока нет",
    "history": "История",
    "save": "Сохранить",
    "cancel": "Отмена",
    "unitToken": "токен",
    "unitSecond": "секунда",
    "unitChar": "символ",
    "unitImage": "изображение",
    "unitTokenShort": "ток",
    "unitSecondShort": "сек",
    "unitCharShort": "симв",
    "unitImageShort": "шт",
    "mediaKinds": {
      "video": "видео",
      "image": "изображение",
      "audio": "аудио",
      "voice": "голос",
      "lipsync": "липсинк",
      "text": "текст"
    },
    "searchPlaceholder": "Поиск",
    "selectModel": "Выберите модель",
    "variantOptional": "Вариант (необязательно)",
    "variantAudio": "аудио",
    "variantVideoInput": "видео-вход",
    "outputPriceShort": "выход",
    "outputPrice": "Цена за выход ($, токены)",
    "pendingBlocksCreate": "У этой комбинации уже есть pending-версия — сначала отмените её",
    "overrideNotice": "Будет создан отдельный тариф компании — действует с сегодня (GMT+3)",
    "pricePerUnit": "{{price}} / {{unit}}",
    "editBlockedPending": "Сначала отмените pending-версию",
    "notSet": "не задано",
    "bulkEdit": "Выбрано: {{count}}",
    "bulkEditTitle": "Изменить {{count}} ставок",
    "selectAll": "Выделить все",
    "clearSelection": "Снять выделение",
    "validity": "Действует с (GMT+3)",
    "provider": "Провайдер",
    "allMediaKinds": "Все медиа",
    "allResolutions": "Все разрешения",
    "allUnits": "Все единицы",
    "allStatuses": "Все статусы",
    "statusActive": "Активные",
    "statusPending": "С ожидающими",
    "statusNotSet": "Не заданы",
    "statusOwn": "Переопределённые",
    "statusGpl": "Унаследованные (GPL)",
    "resetFilters": "Сбросить",
    "columnsToggle": "Колонки",
    "columnsDefault": "По умолчанию"
  },
  "plans": {
    "headTitle": "Планы биллинга",
    "title": "Планы",
    "catalog": "Каталог планов",
    "assignmentsTitle": "Назначения и покупки",
    "create": "Новый план",
    "newVersion": "Новая версия",
    "archive": "Архивировать",
    "archiveConfirm": "Архивировать план «{{code}}»? Новые назначения станут недоступны, действующие не изменятся.",
    "assign": "Назначить / продать",
    "empty": "Планов пока нет",
    "assignmentsEmpty": "Назначений пока нет",
    "history": "История",
    "columns": {
      "code": "Код",
      "name": "Название",
      "kind": "Тип",
      "terms": "Условия",
      "price": "Цена",
      "status": "Статус",
      "assignments": "Назначений",
      "createdBy": "Создал",
      "actions": "Действия"
    },
    "kind": {
      "discount": "Скидочный",
      "deposit": "Депозитный"
    },
    "status": {
      "active": "Активен",
      "archived": "Архив"
    },
    "termsDiscount": "скидка {{percent}}% · {{period}}",
    "periodMonths": "{{count}} мес.",
    "periodDays": "{{count}} дн.",
    "termsDeposit": "{{price}} → {{credit}}",
    "assignmentColumns": {
      "company": "Компания",
      "plan": "План",
      "period": "Период",
      "autoRenew": "Автопродление",
      "state": "Статус",
      "createdBy": "Кто",
      "actions": "Действия"
    },
    "state": {
      "pending": "Ожидает",
      "active": "Действует",
      "expired": "Истёк",
      "purchased": "Куплен",
      "refunded": "Возврат",
      "cancelled": "отменено",
      "expiring": "истекает"
    },
    "cancelAssignment": "Отменить",
    "cancelAssignmentConfirm": "Отменить назначение «{{plan}}» для {{company}}? Активный план действует до конца сегодняшнего дня, ожидающий будет удалён.",
    "refund": "Возврат",
    "dialog": {
      "createTitle": "Новый план",
      "newVersionTitle": "Новая версия: {{code}}",
      "newVersionNotice": "Текущая активная версия будет заархивирована; уже проданные назначения сохранят прежние условия.",
      "kind": "Тип плана",
      "code": "Код (слаг)",
      "name": "Название",
      "description": "Описание",
      "discountPercent": "Скидка (%)",
      "periodUnit": "Период",
      "periodMonths": "месяцы",
      "periodDays": "дни",
      "periodValue": "Длительность",
      "priceRubOptional": "Цена (₽, справочная)",
      "priceRub": "Цена (₽)",
      "creditRub": "Зачисляется (₽)",
      "previewDiscount": "Скидка {{percent}}% на {{period}}",
      "previewDeposit": "Клиент платит {{price}}, на счёт зачисляется {{credit}} (бонус {{bonus}})",
      "save": "Сохранить",
      "cancel": "Отмена"
    },
    "assignDialog": {
      "title": "Назначить / продать план",
      "company": "Компания",
      "selectCompany": "Выберите компанию",
      "plan": "План",
      "selectPlan": "Выберите план",
      "validFrom": "Дата начала (МСК)",
      "validFromHint": "Не раньше сегодняшнего дня (МСК)",
      "autoRenew": "Автопродление",
      "depositNotice": "Покупка пакета: клиент платит {{price}}, на основной счёт зачислится {{credit}}",
      "submitAssign": "Назначить",
      "submitPurchase": "Провести покупку"
    },
    "refundDialog": {
      "title": "Возврат депозита",
      "amount": "Сумма возврата (₽)",
      "memo": "Комментарий",
      "warning": "Компенсирующая проводка спишет сумму со счёта. Если кредит уже потрачен, баланс уйдёт в минус.",
      "creditHint": "Зачислено по покупке: {{credit}}",
      "submit": "Провести возврат"
    }
  },
  "promotions": {
    "headTitle": "Акции биллинга",
    "title": "Акции",
    "catalog": "Каталог акций",
    "create": "Новая акция",
    "replace": "Изменить",
    "disable": "Выключить",
    "disableConfirm": "Выключить акцию «{{name}}» сейчас? Новые генерации пойдут без скидки.",
    "empty": "Акций пока нет",
    "columns": {
      "kind": "Пресет",
      "name": "Название",
      "discount": "Скидка",
      "period": "Период (МСК)",
      "status": "Статус",
      "createdBy": "Автор",
      "endedBy": "Остановил",
      "actions": "Действия"
    },
    "kinds": {
      "non_canvas_image": "Изображения вне холста"
    },
    "status": {
      "active": "Активна",
      "pending": "Запланирована",
      "ended": "Завершена"
    },
    "infinite": "Без срока",
    "dialog": {
      "createTitle": "Новая акция",
      "replaceTitle": "Изменить акцию",
      "kind": "Пресет",
      "name": "Название",
      "discount": "Скидка, %",
      "startsAt": "Начало",
      "endsAt": "Конец",
      "startsAtPlaceholder": "Дата начала",
      "endsAtPlaceholder": "Дата конца",
      "startsAtClear": "Очистить дату начала",
      "endsAtClear": "Очистить дату конца",
      "memo": "Комментарий",
      "cancel": "Отмена",
      "submitCreate": "Создать",
      "submitReplace": "Сохранить",
      "startsNow": "Пусто = начать сейчас (МСК)",
      "endsOpen": "Пусто = без срока окончания"
    }
  },
  "accounts": {
    "headTitle": "Счета компаний",
    "title": "Счета",
    "empty": "Компаний нет",
    "columns": {
      "company": "Компания",
      "enforcement": "Режим",
      "balance": "Баланс",
      "held": "Заморожено",
      "available": "Доступно",
      "accounts": "Счетов",
      "unsettled": "Расхождения",
      "currencyMismatch": "Валюта ≠ валюте счёта",
      "links": "Ссылки"
    },
    "unsettledHint": "Успешные генерации с выручкой, по которым не прошло списание после включения режима",
    "currencyMismatchHint": "События, у которых валюта не совпадает с валютой счёта: списание не проводится. Открыть в журнале",
    "defaultBadge": "основной",
    "archivedBadge": "архив",
    "noAccounts": "нет счетов",
    "companyCardLink": "Карточка",
    "statementLink": "Выписка",
    "enforcementSince": "Режим включён {{date}}"
  },
  "enforcement": {
    "off": "Выключен",
    "shadow": "Наблюдение",
    "enforced": "Контроль",
    "offHint": "Биллинг не ведётся: генерации не резервируют и не списывают средства.",
    "shadowHint": "Считаем и списываем для выверки; генерации блокируются после исчерпания допустимого минуса.",
    "enforcedHint": "Генерации резервируют средства и блокируются при нехватке."
  },
  "statement": {
    "headTitle": "Выписка счёта",
    "title": "Выписка: {{account}}",
    "account": "Счёт",
    "balance": "Баланс",
    "held": "Заморожено",
    "available": "Доступно",
    "allKinds": "Все виды",
    "empty": "Проводок нет",
    "columns": {
      "created_at": "Дата (МСК)",
      "kind": "Вид",
      "balance_delta": "Δ баланс",
      "held_delta": "Δ заморозка",
      "balance_after": "Баланс после",
      "held_after": "Заморожено после",
      "created_by": "Кто",
      "memo": "Комментарий",
      "source": "Источник"
    },
    "kind": {
      "deposit": "Пополнение",
      "adjustment": "Корректировка",
      "transfer_in": "Перенос (зачисление)",
      "transfer_out": "Перенос (списание)",
      "hold": "Заморозка",
      "hold_release": "Разморозка",
      "settle": "Списание",
      "promo": "Промокод",
      "settle_reversal": "Сторно списания"
    },
    "system": "система",
    "openUsageEvent": "Открыть в журнале",
    "toAccounts": "Все счета",
    "actions": {
      "deposit": "Зачислить",
      "adjust": "Корректировка",
      "transfer": "Перенос",
      "setDefault": "Сделать основным",
      "archive": "Архивировать",
      "create": "Создать счёт"
    },
    "confirmSetDefault": "Сделать счёт «{{name}}» основным? Новые заморозки и списания пойдут с него.",
    "confirmArchive": "Архивировать счёт «{{name}}»? Нужны нулевой баланс и отсутствие заморозок."
  },
  "accountDialogs": {
    "depositTitle": "Зачислить на баланс",
    "adjustTitle": "Корректировка",
    "transferTitle": "Перенос между счетами",
    "createTitle": "Новый счёт",
    "account": "Счёт",
    "amountRub": "Сумма (₽)",
    "signedAmountRub": "Сумма (₽, со знаком)",
    "amountIn": "Сумма ({{currency}})",
    "signedAmountIn": "Сумма ({{currency}}, со знаком)",
    "currency": "Валюта",
    "priceList": "Прайс-лист",
    "priceListBase": "Базовый {{currency}}",
    "foreignHint": "Валютный счёт: только для списаний проектов, пополнение — вручную. Основным стать не может.",
    "settingsTitle": "Настройки счёта",
    "overdraft": "Допустимый минус в shadow ({{currency}})",
    "overdraftDefault": "по умолчанию",
    "overdraftHint": "Пусто — по умолчанию: у рублёвого счёта лимит компании, у валютного — 0.",
    "save": "Сохранить",
    "adjustHint": "Положительная сумма увеличивает баланс, отрицательная — уменьшает. Комментарий обязателен.",
    "memo": "Комментарий",
    "memoRequired": "Комментарий (обязательно)",
    "fromAccount": "Со счёта",
    "toAccount": "На счёт",
    "name": "Название счёта",
    "submit": "Провести",
    "createSubmit": "Создать",
    "cancel": "Отмена"
  },
  "companyCard": {
    "enforcement": "Режим биллинга",
    "enforcementConfirmEnforced": "Включить режим «Контроль»? Генерации без средств на счёте будут блокироваться.",
    "enforcementNeedsAccount": "Недоступно: сначала создайте компании основной счёт.",
    "internalNotice": "Системная компания — не биллится",
    "plan": "Активный план",
    "noPlan": "План не назначен",
    "planTill": "до {{date}}",
    "planExpiringBadge": "истекает",
    "planExpiresIn": "истекает через {{count}} дн.",
    "planExpiredBadge": "истёк",
    "autoRenew": "автопродление",
    "assignPlan": "Назначить план",
    "plansLink": "Управление планами",
    "accountsTitle": "Счета",
    "defaultAccount": "Основной счёт",
    "noAccounts": "Счетов нет — создайте основной счёт",
    "accountsCount": "счетов: {{count}}",
    "depositPurchases": "депозитных покупок: {{count}}",
    "createAccount": "Создать счёт",
    "statement": "Счета и выписка",
    "balance": "Баланс",
    "held": "Заморожено",
    "available": "Доступно"
  },
  "client": {
    "headTitle": "Биллинг",
    "title": "Биллинг",
    "nav": {
      "dashboard": "Сводка",
      "usage": "Журнал",
      "accounts": "Счета",
      "entries": "Операции",
      "limits": "Лимиты",
      "requisites": "Реквизиты",
      "payment": "Оплата",
      "reports": "Отчёты"
    },
    "limitsUnavailable": "В этой компании лимиты расходов не действуют.",
    "discount": "Скидка {{percent}}%",
    "autoRenew": "Автопродление включено",
    "planDaysLeftBadge_one": "остался {{count}} день",
    "planDaysLeftBadge_few": "осталось {{count}} дня",
    "planDaysLeftBadge_many": "осталось {{count}} дней",
    "planExpiredBadge": "истёк",
    "usageCount": "Генераций",
    "spendPeriod": "Расходы за период",
    "daysLeftLabel": "Хватит на",
    "daysLeftValue_one": "~{{count}} день",
    "daysLeftValue_few": "~{{count}} дня",
    "daysLeftValue_many": "~{{count}} дней",
    "daysLeftHint": "Среднее списание {{amount}} в день за последние {{days}}. Прогноз обновляется по мере накопления истории.",
    "daysLeftHintEmpty": "Трат пока не было — прогноз появится после первых списаний.",
    "forecastWindowDays_one": "{{count}} день",
    "forecastWindowDays_few": "{{count}} дня",
    "forecastWindowDays_many": "{{count}} дней",
    "exportXlsx": "Экспорт XLSX",
    "charts": {
      "dynamicsTitle": "Динамика расходов",
      "structureTitle": "Структура расходов",
      "metricSpend": "Расходы",
      "spendShare": "% расходов",
      "heatmapTitle": "Активность за год",
      "heatmapLess": "меньше",
      "heatmapMore": "больше",
      "heatmapHint": "Клик по дню или месяцу — выбрать период, shift + клик — диапазон",
      "heatmapCountValue_one": "{{count}} генерация",
      "heatmapCountValue_few": "{{count}} генерации",
      "heatmapCountValue_many": "{{count}} генераций",
      "byProjects": "По проектам",
      "byUsers": "По пользователям"
    },
    "allAccounts": "Все счета",
    "accountsTitle": "Счета",
    "accountCreate": "Создать счёт",
    "accountCreateHint": "Отдельный счёт-бюджет: переносите на него средства и привязывайте проекты.",
    "accountTransferHint": "Между своими счетами переносятся только свободные средства (баланс минус заморозка).",
    "accountRename": "Переименовать",
    "accountRenameTitle": "Переименовать счёт",
    "accountRenameSubmit": "Сохранить",
    "accountSetDefault": "Сделать основным",
    "accountArchive": "Архивировать",
    "accountActions": "Действия",
    "currencyAccounts": {
      "title": "Валютные счета",
      "openSlice": "Показать дашборд по этому счёту",
      "blocked": "Минус исчерпан",
      "negative": "В минусе",
      "projects_one": "{{formatted}} проект",
      "projects_few": "{{formatted}} проекта",
      "projects_many": "{{formatted}} проектов"
    },
    "accountProjects": "Проектов",
    "confirmSetDefault": "Сделать «{{name}}» основным счётом? С него пойдут списания проектов без своего бюджета.",
    "confirmArchive": "Заархивировать «{{name}}»? Нужен нулевой баланс, без заморозки и без привязанных проектов.",
    "projectAccountsTitle": "Проекты и счета",
    "projectAccountsEmpty": "Проектов пока нет",
    "projectName": "Проект",
    "projectDefaultAccount": "По умолчанию",
    "projectDefaultAccountNamed": "По умолчанию · {{name}}",
    "projectAccountLabel": "Счёт для списаний",
    "projectAccountInstantSave": "Сохраняется сразу, отдельно от остальных настроек проекта.",
    "projectAccountAria": "Счёт проекта «{{project}}»",
    "projectAccountsTooltip": "Генерации списываются со счёта проекта. Если на нём кончатся средства, генерации проекта блокируются — с основного счёта деньги не берутся.",
    "defaultBadge": "основной",
    "balance": "Баланс",
    "held": "Заморожено",
    "available": "Доступно",
    "availableBreakdown": "из {{balance}} · заморожено {{held}}",
    "shadowModeNote": "Режим выверки: генерации блокируются после исчерпания допустимого минуса {{limit}}.",
    "entriesTitle": "Последние операции",
    "entriesEmpty": "Операций пока нет",
    "accountsEmpty": "Счетов нет",
    "entryDate": "Дата",
    "entryAccount": "Счёт",
    "entryKind": "Операция",
    "entryDelta": "Сумма",
    "entryAfter": "Баланс после",
    "entryMemo": "Комментарий",
    "lowBalanceTitle": "Недостаточно средств",
    "lowBalanceBody": "Баланс: {{balance}}. Новые генерации заблокированы.",
    "overdraftLimitTitle": "Исчерпан допустимый минус",
    "overdraftLimitBody": "Доступно: {{available}}. Допустимый минус: {{limit}}. Новые генерации приостановлены.",
    "topUp": "Пополнить баланс",
    "topUpShort": "Пополнить →",
    "topUpUnavailableHint": "Пополнение по счёту ещё не настроено: платформа не заполнила свои реквизиты. Напишите менеджеру.",
    "lowBalanceInvoiceIssued": "Счёт № {{number}} сформирован, ждём оплату.",
    "discountLabel": "Скидка",
    "discountValue": "{{percent}}%",
    "noDiscount": "Скидка не подключена",
    "planExpiresTodayBadge": "истекает сегодня",
    "discountLabelTill": "Скидка до {{date}}",
    "journalButton": "Журнал генераций",
    "promoCodeButton": "У меня есть промокод",
    "promoCodeTitle": "Промокод",
    "promoCodeDescription": "Сумма промокода зачислится на основной счёт компании.",
    "promoCodeField": "Код",
    "promoCodeSubmit": "Применить",
    "promoCodeCancel": "Отмена",
    "promoCodeHint": "Регистр не важен. Код можно применить один раз.",
    "promoCodeApplying": "Проверяем",
    "promoCodeSuccessApplied": "Промокод {{code}} применён",
    "promoCodeSuccessAccount": "Основной счёт",
    "promoCodeSuccessDone": "Отлично"
  },
  "supplier": {
    "title": "Реквизиты поставщика",
    "headTitle": "Реквизиты поставщика",
    "notConfiguredTitle": "Реквизиты не заполнены",
    "notConfiguredBody": "Пока не заполнены наименование, ИНН, расчётный счёт, БИК, корсчёт, банк и не выбрана оферта, клиенты не могут выставлять счета.",
    "save": "Сохранить",
    "saving": "Сохраняем…",
    "saveNote": "Изменения действуют на новые счета: у выставленных хранится снимок реквизитов, он не переписывается.",
    "org": {
      "title": "Организация",
      "legalName": "Полное наименование",
      "legalNameNote": "С организационно-правовой формой, как в ЕГРЮЛ.",
      "shortName": "Краткое наименование",
      "shortNameNote": "Печатается в шапке счёта и в поле «Получатель».",
      "inn": "ИНН",
      "lookup": "Найти по ИНН",
      "lookupNote": "Заполнит наименование, КПП, ОГРН, адрес и руководителя из ЕГРЮЛ. Поля, введённые вручную, останутся как есть.",
      "lookupUnavailable": "Автозаполнение не настроено — задайте ключ DaData ниже и сохраните, либо заполните поля вручную.",
      "lookupFailed": "Не удалось получить данные — заполните поля вручную.",
      "kpp": "КПП",
      "kppNote": "У ИП КПП нет — оставьте пустым.",
      "ogrn": "ОГРН / ОГРНИП",
      "ogrnNote": "13 знаков у организации, 15 у ИП.",
      "legalAddress": "Юридический адрес"
    },
    "bank": {
      "title": "Банковские реквизиты",
      "name": "Банк получателя",
      "nameNote": "Платёжное наименование банка — как в поле «Банк получателя» платёжного поручения.",
      "bic": "БИК",
      "bicNote": "По БИК подставятся банк и корреспондентский счёт.",
      "corrAccount": "Корреспондентский счёт",
      "settlementAccount": "Расчётный счёт",
      "settlementAccountNote": "20 цифр. Пробелы и разделители убираются при сохранении."
    },
    "vat": {
      "title": "НДС",
      "mode": "Режим НДС",
      "modes": {
        "none": "Без НДС",
        "included": "В том числе НДС"
      },
      "rate": "Ставка НДС",
      "rate22Hint": "Базовая ставка с 01.01.2026.",
      "rateNote": "Ставка попадает в счёт и в назначение платежа. Уже выставленные счета её не меняют.",
      "exemptionReason": "Основание освобождения",
      "exemptionPlaceholder": "НДС не облагается на основании пп. 26 п. 2 ст. 149 НК РФ",
      "exemptionNote": "Текст печатается в счёте вместо суммы налога. Если пусто — будет просто «Без НДС»."
    },
    "sign": {
      "title": "Подписанты и печать",
      "directorName": "ФИО руководителя",
      "directorPost": "Должность руководителя",
      "directorPostPlaceholder": "Генеральный директор",
      "accountantName": "ФИО главного бухгалтера",
      "accountantNote": "Пусто — строка «Главный бухгалтер» в счёте не печатается.",
      "stamp": "Факсимиле подписи и печати",
      "stampNote": "Печать необязательна с 2015 года (ФЗ от 06.04.2015 № 82-ФЗ), но бухгалтерия контрагента её обычно ждёт. Лучше PNG с прозрачным фоном.",
      "stampUpload": "Загрузить файл",
      "stampReplace": "Заменить файл",
      "stampRemove": "Удалить",
      "stampRemoveConfirm": "Удалить факсимиле? Новые счета будут печататься без подписи и печати.",
      "stampEmpty": "Файл не загружен",
      "stampPending": "Будет загружен при сохранении: {{name}}"
    },
    "invoice": {
      "title": "Счета",
      "numberPrefix": "Префикс номера",
      "numberPrefixNote": "Подставляется перед порядковым номером счёта. Можно оставить пустым.",
      "dueDays": "Срок действия счёта, дней",
      "dueDaysNote": "Через столько дней счёт считается просроченным. По умолчанию 5.",
      "minAmount": "Минимальная сумма пополнения, ₽",
      "minAmountNote": "0 или пусто — минимум отключён. На счета, выставленные платформой, минимум не действует.",
      "minAcquiringAmount": "Минимум оплаты картой/СБП, ₽",
      "minAcquiringAmountNote": "Для частных аккаунтов (эквайринг ЮKassa). По умолчанию 1000 ₽. 0 — минимум выключен. На банковские счета ЮЛ не действует. Из Creator Studio можно оплатить меньше минимума — недостачу или полную стоимость генерации.",
      "offer": "Оферта",
      "offerNone": "Без оферты",
      "offerOption": "{{title}} · ред. {{version}}",
      "offerNote": "Редакция фиксируется на каждом счёте: смена оферты не меняет уже выставленные.",
      "offerRequired": "Без выбранной оферты выставление счетов заблокировано.",
      "itemTitleTemplate": "Шаблон позиции счёта",
      "itemTitleTemplateNote": "Единственная строка в таблице счёта, до 255 знаков. Пусто — действует шаблон из подсказки.",
      "purposeTemplate": "Шаблон назначения платежа",
      "purposeTemplateNote": "Поле 24 платёжного поручения, до 210 знаков — длинное назначение сокращается автоматически. Обязательна переменная %{invoice_number}; строка НДС допишется в конец сама, если её нет.",
      "variablesTitle": "Переменные шаблонов",
      "previewTitle": "Превью на примере",
      "previewItemTitle": "Позиция счёта",
      "previewPurpose": "Назначение платежа",
      "contactEmail": "Email для связи",
      "contactPhone": "Телефон для связи",
      "contactNote": "Контакты печатаются в подвале счёта."
    },
    "dadata": {
      "title": "Автозаполнение по ИНН (DaData)",
      "description": "Вводим ИНН — реквизиты подставляются из ЕГРЮЛ, а БИК разворачивается в наименование банка и корсчёт. Тот же ключ работает и в форме реквизитов клиента.",
      "key": "API-ключ DaData",
      "keyPlaceholderSaved": "Ключ сохранён — оставьте пустым, чтобы не менять",
      "keyPlaceholderEmpty": "Вставьте ключ DaData",
      "keyNote": "После сохранения ключ не показывается. Пустое поле НЕ стирает сохранённый ключ.",
      "keyNoteEnv": "Если ключ здесь не задан, берётся значение переменной окружения DADATA_API_KEY.",
      "statusOn": "Автозаполнение включено",
      "statusOff": "Автозаполнение выключено"
    }
  },
  "platformInvoices": {
    "headTitle": "Счета на оплату",
    "title": "Счета на оплату",
    "empty": "Счетов нет",
    "issueInvoice": "Выставить счёт за компанию",
    "supplierNotConfigured": "Реквизиты поставщика не заполнены — счета выставлять нельзя. Заполните раздел «Реквизиты поставщика».",
    "supplierSetupLink": "Заполнить реквизиты поставщика",
    "pendingOrders": "Непроверенных ПП: {{count}}",
    "pendingOrdersHint": "Платёжные поручения, которые клиенты приложили, но никто ещё не проверил",
    "pendingOrderRow": "Приложено платёжное поручение — на проверке",
    "expired": "Срок истёк",
    "downloadInvoice": "Скачать счёт",
    "filters": {
      "allStatuses": "Все статусы",
      "allCompanies": "Все компании",
      "companySearch": "Поиск компании",
      "companyEmpty": "Компания не найдена",
      "searchPlaceholder": "Номер счёта",
      "overpaid": "Переплата",
      "expired": "Просроченные"
    },
    "columns": {
      "number": "Номер",
      "order": "Заказ",
      "company": "Компания",
      "issued_on": "Дата",
      "due_on": "Срок",
      "amount": "Сумма",
      "paid": "Оплачено",
      "outstanding": "Остаток",
      "status": "Статус",
      "payer_inn": "ИНН плательщика",
      "actions": "Действия"
    },
    "status": {
      "issued": "Ожидает оплаты",
      "partially_paid": "Оплачен частично",
      "paid": "Оплачен",
      "overpaid": "Оплачен",
      "cancelled": "Отменён"
    },
    "overpaidNote": "переплата {{amount}}",
    "paymentOrderStatus": {
      "pending": "На проверке",
      "accepted": "Принят",
      "rejected": "Отклонён"
    },
    "actions": {
      "accept": "Зачислить платёж",
      "acceptShort": "Зачислить",
      "cancel": "Отменить счёт",
      "reissue": "Перевыставить",
      "rejectOrder": "Отклонить ПП"
    },
    "panel": {
      "title": "Счёт № {{number}}",
      "overview": "Обзор",
      "billingAccount": "Счёт зачисления",
      "purpose": "Назначение платежа",
      "vat": "НДС",
      "vatIncluded": "В т.ч. НДС {{rate}}% — {{amount}}",
      "vatNone": "Без НДС",
      "contract": "Основание",
      "createdBy": "Кто выставил",
      "cancelReason": "Причина отмены",
      "acceptUnavailable": "Зачислить платёж можно только по счёту, который ожидает оплаты или оплачен частично",
      "cancelUnavailable": "Отменить можно только счёт без зачисленных платежей: деньги с баланса возвращают корректировкой",
      "payer": {
        "title": "Плательщик",
        "name": "Наименование",
        "inn": "ИНН",
        "account": "Расчётный счёт"
      },
      "payments": {
        "title": "Зачисленные платежи",
        "empty": "Платежей нет"
      },
      "orders": {
        "title": "Платёжные поручения",
        "empty": "Платёжных поручений нет",
        "number": "ПП № {{number}}",
        "withoutNumber": "ПП без номера",
        "noFile": "файла нет",
        "rejectionReason": "Причина отклонения: {{reason}}",
        "accountMatch": "совпадает",
        "accountUnknown": "не найден у компании"
      },
      "companyAccounts": {
        "title": "Р/с компании",
        "empty": "У компании нет активных банковских счетов.",
        "defaultBadge": "основной",
        "expectedBadge": "ожидаемый"
      }
    },
    "reissueConfirm": "Перевыставить счёт № {{number}}? Старый счёт будет отменён, новый сохранит номер заказа."
  },
  "invoiceDialogs": {
    "cancel": "Отмена",
    "accept": {
      "title": "Зачислить платёж",
      "subtitle": "Счёт № {{number}} · {{company}}",
      "submit": "Зачислить",
      "warning": "Деньги зачисляются на баланс компании немедленно и необратимо. Ошибку исправляют корректировкой баланса, а не отменой платежа.",
      "paymentOrder": "Платёжное поручение",
      "noPaymentOrder": "Без платёжного поручения",
      "orderWithoutNumber": "ПП без номера",
      "amountRub": "Сумма поступления, ₽",
      "receivedOn": "Дата поступления",
      "outstandingHint": "Остаток по счёту: {{amount}}. Частичная оплата и переплата допустимы.",
      "overpayWarning": "Сумма больше остатка по счёту — счёт будет отмечен как оплаченный с переплатой, на баланс уйдёт вся введённая сумма.",
      "memo": "Комментарий"
    },
    "reject": {
      "title": "Отклонить платёжное поручение",
      "subtitle": "ПП {{number}}",
      "submit": "Отклонить",
      "hint": "Счёт останется открытым: клиент сможет приложить другой файл.",
      "reason": "Причина отклонения"
    },
    "cancelInvoice": {
      "title": "Отменить счёт",
      "subtitle": "Счёт № {{number}}",
      "submit": "Отменить счёт",
      "warning": "Счёт неизменяем: отменённый номер не переиспользуется, вместо него выставляется новый счёт.",
      "reason": "Причина отмены"
    },
    "issue": {
      "title": "Выставить счёт за компанию",
      "submit": "Выставить",
      "hint": "Счёт выставляется по реквизитам плательщика компании и зачисляется на выбранный счёт-баланс (по умолчанию — основной). Если реквизитов нет, сервер вернёт ошибку.",
      "company": "Компания",
      "companySearch": "Поиск компании",
      "companyEmpty": "Компания не найдена",
      "companyPlaceholder": "Выберите компанию",
      "amountRub": "Сумма счёта, ₽",
      "minAmountHint": "Клиентский минимум — {{amount}}; на счета от платформы не действует.",
      "billingAccount": "Зачислить на счёт",
      "contractReference": "Договор № (необязательно)"
    }
  },
  "pendingPayment": {
    "title": "Платёж по счёту № {{number}} ждёт акцепта",
    "outstanding": "к оплате {{amount}}",
    "order": "ПП № {{number}}",
    "orderPaidOn": "от {{date}}",
    "orderAmount": "на {{amount}}",
    "accept": "Акцептовать"
  },
  "invoices": {
    "expired": "Срок истёк",
    "download": "Скачать счёт",
    "sendEmail": "Отправить бухгалтеру",
    "sendEmailTitle": "Отправить счёт бухгалтеру",
    "sendEmailFor": "Счёт № {{number}} уйдёт письмом с PDF-вложением.",
    "sendEmailHint": "Мы отправим письмо со счётом в PDF на указанный адрес.",
    "sendEmailAddress": "Email бухгалтера",
    "sendEmailSubmit": "Отправить",
    "paymentOrderNumbered": "ПП № {{number}}",
    "paymentOrderUnnumbered": "ПП без номера",
    "statusLabel": {
      "issued": "Ожидает оплаты",
      "partially_paid": "Оплачен частично",
      "paid": "Оплачен",
      "overpaid": "Оплачен",
      "cancelled": "Отменён"
    },
    "overpaidNote": "переплата {{amount}}",
    "paymentOrderStatus": {
      "pending": "На проверке",
      "accepted": "Принят",
      "rejected": "Отклонён"
    },
    "print": {
      "chromeTitle": "Счёт № {{number}}",
      "headTitle": "Счёт № {{number}}",
      "print": "Печать",
      "paymentOrdersTitle": "Платёжные поручения",
      "paymentOrderUploaded": "Загружено {{at}}",
      "paymentOrderRejected": "Причина отклонения: {{reason}}"
    },
    "title": "Счета на оплату",
    "issue": "Пополнить баланс",
    "issueInvoice": "Сформировать счёт",
    "supplierNotConfigured": "Пополнение по счёту ещё не настроено — напишите менеджеру:",
    "needRequisites": "Сначала заполните реквизиты — они попадут в счёт.",
    "empty": "Счетов пока нет. Сформируйте счёт на пополнение, оплатите его с расчётного счёта — после поступления денег мы зачислим их на баланс.",
    "number": "№ счёта",
    "issuedOn": "Сформирован",
    "dueOn": "Оплатить до",
    "amount": "Сумма",
    "paidAmount": "Оплачено",
    "outstanding": "Остаток",
    "status": "Статус",
    "actions": "Действия",
    "open": "Открыть счёт",
    "uploadPaymentOrder": "Приложить платёжное поручение",
    "attachPaymentOrder": "Приложить платёжное поручение",
    "cancel": "Отменить счёт",
    "cancelConfirm": "Отменить счёт № {{number}}? Оплатить его будет нельзя — сформируйте новый.",
    "reissue": "Перевыставить счёт",
    "reissueConfirm": "Перевыставить счёт № {{number}}? Старый счёт будет отменён, новый сохранит номер заказа.",
    "paymentOrdersOf": "Платёжные поручения к счёту № {{number}}:",
    "issueTitle": "Пополнение баланса",
    "issueHint": "Номер и PDF создаются сразу. Счёт неизменяем: ошиблись в сумме — отмените его и сформируйте новый.",
    "issueSubmit": "Сформировать счёт",
    "minAmountHint": "Минимум пополнения — {{amount}}",
    "topUpSummaryTotal": "К оплате {{amount}}",
    "topUpSummaryVat": "в т.ч. НДС {{rate}}% {{amount}}",
    "topUpSummaryNoVat": "Без НДС",
    "topUpSummaryDue": "оплатить до {{date}}",
    "awaitingBannerTitle": "Счёт № {{number}} ожидает оплаты",
    "awaitingBannerAmount": "Сумма {{amount}}",
    "awaitingBannerOutstanding": "остаток {{amount}}",
    "awaitingBannerDue": "оплатить до {{date}}",
    "awaitingBannerPending": "Платёжное поручение на проверке",
    "issuedBannerTitle": "Счёт № {{number}} на {{amount}} ₽ сформирован",
    "issuedBannerStep1": "Скачайте счёт или скопируйте реквизиты для платёжки.",
    "issuedBannerStep2": "Оплатите с расчётного счёта компании до {{date}}.",
    "issuedBannerStep3": "После поступления денег мы зачислим их на баланс и напишем вам.",
    "copyRequisites": "Скопировать реквизиты",
    "copyRequisitesDone": "Скопировано",
    "paymentOrderTitle": "Приложить платёжное поручение",
    "paymentOrderFor": "Счёт № {{number}}",
    "paymentOrderHint": "Необязательно, но ускоряет проверку платежа.",
    "paymentOrderPick": "Выбрать файл",
    "paymentOrderNoFile": "Файл не выбран — PDF, скан или выгрузка из клиент-банка",
    "paymentOrderNumber": "Номер ПП",
    "paymentOrderPaidOn": "Дата платежа",
    "paymentOrderPayerAccount": "Р/с плательщика",
    "paymentOrderSubmit": "Приложить",
    "payerBankAccount": "С какого счёта будете платить",
    "billingAccount": "Зачислить на счёт",
    "billingAccountTooltip": "Зачисляется на счёт «{{name}}»"
  },
  "requisites": {
    "title": "Реквизиты",
    "add": "Добавить реквизиты",
    "emptyTitle": "Добавьте реквизиты, чтобы пополнить баланс",
    "emptyHint": "Понадобятся наименование, ИНН и банковский счёт — те же, что в вашей платёжке.",
    "stateWarning": "по данным ЕГРЮЛ организация не действующая",
    "edit": "Изменить",
    "innShort": "ИНН / КПП",
    "ogrn": "ОГРН",
    "legalAddress": "Юр. адрес",
    "bankName": "Банк",
    "settlementAccount": "Расчётный счёт",
    "createTitle": "Реквизиты плательщика",
    "topUpStepRequisites": "Реквизиты",
    "topUpStepAmount": "Сумма",
    "editTitle": "Изменить реквизиты",
    "dialogHint": "Эти данные попадут в счёт как есть — сверьте их с уставными документами.",
    "save": "Сохранить",
    "sectionParty": "Организация",
    "sectionBank": "Банковские реквизиты",
    "sectionContacts": "Подписант и контакты",
    "bankHint": "Обязательны — по расчётному счёту мы сопоставляем ваш платёж.",
    "payerKind": "Вид плательщика",
    "inn": "ИНН",
    "kpp": "КПП",
    "legalName": "Полное наименование",
    "shortName": "Краткое наименование",
    "bankBic": "БИК",
    "bankCorrAccount": "Корр. счёт",
    "lookupParty": "Найти по ИНН",
    "lookupUnavailable": "Автозаполнение не настроено — заполните поля вручную.",
    "lookupFailed": "Не удалось получить данные — заполните поля вручную.",
    "directorName": "Руководитель",
    "directorPost": "Должность",
    "contactEmail": "Email",
    "contactPhone": "Телефон",
    "kind": {
      "organization": "Организация",
      "entrepreneur": "ИП",
      "individual": "Физлицо"
    }
  },
  "bankAccounts": {
    "title": "Банковские счета",
    "add": "Добавить счёт",
    "defaultBadge": "основной",
    "bic": "БИК",
    "makeDefault": "Сделать основным",
    "edit": "Изменить",
    "archive": "Архивировать",
    "archiveBlocked": "Это единственный активный счёт — без него не сформировать счёт на пополнение",
    "archiveConfirm": "Заархивировать счёт «{{name}}»? Уже сформированные счета останутся без изменений.",
    "createTitle": "Банковский счёт",
    "editTitle": "Изменить банковский счёт",
    "dialogHint": "По расчётному счёту мы сопоставляем ваш платёж — укажите тот, с которого будете платить.",
    "save": "Сохранить",
    "label": "Метка",
    "labelPlaceholder": "Например, «Сбер» или «Точка»",
    "makeDefaultCheckbox": "Сделать основным"
  },
  "onlinePayments": {
    "title": "Онлайн-платежи ЮKassa",
    "subtitle": "Пополнения картой и СБП. Акцепт не нужен — деньги уже на балансе.",
    "allStatuses": "Все статусы",
    "filterStatus": "Статус",
    "empty": "Пока нет онлайн-платежей",
    "total": "Всего: {{count}}",
    "colWhen": "Когда",
    "colCompany": "Компания",
    "colAmount": "Сумма",
    "colStatus": "Статус",
    "colIntent": "Назначение",
    "colYookassa": "ID ЮKassa"
  },
  "promoCodes": {
    "headTitle": "Промокоды",
    "title": "Промокоды",
    "tabs": {
      "codes": "Промокоды",
      "redemptions": "Применения"
    },
    "create": "Новый промокод",
    "empty": "Промокодов не найдено",
    "pause": "Пауза",
    "resume": "Возобновить",
    "pauseConfirm": "Поставить промокод «{{code}}» на паузу? Применять его будет нельзя, пока не возобновите; уже зачисленное не отменяется.",
    "pauseSelectedConfirm": "Поставить на паузу выбранные промокоды ({{count}})? Применять их будет нельзя, пока не возобновите.",
    "noExpiry": "бессрочно",
    "limitClosed": "{{count}} комп.",
    "kind": {
      "open": "Открытый",
      "closed": "Закрытый"
    },
    "state": {
      "active": "Действует",
      "exhausted": "Исчерпан",
      "expired": "Истёк",
      "paused": "Пауза"
    },
    "allKinds": "Все типы",
    "allStates": "Все статусы",
    "allCompanies": "Все компании",
    "allCreators": "Все создатели",
    "allCodes": "Все коды",
    "allUsers": "Все пользователи",
    "columns": {
      "id": "ID",
      "code": "Код",
      "kind": "Тип",
      "amount": "Номинал",
      "redeemed": "Использовано",
      "limit": "Лимит",
      "expires": "Действует до",
      "state": "Статус",
      "comment": "Комментарий",
      "created_by": "Создал",
      "created_at": "Создан",
      "landing_url": "Ссылка"
    },
    "redemptionColumns": {
      "id": "ID",
      "created_at": "Дата (МСК)",
      "company": "Компания",
      "code": "Код",
      "kind": "Тип кода",
      "amount": "Сумма",
      "redeemed_by": "Кто применил"
    },
    "redemptionsEmpty": "Применений не найдено",
    "statement": "Выписка",
    "actions": {
      "copyLink": "Копировать ссылку",
      "copyImage": "Копировать картинку QR",
      "downloadSvg": "Скачать SVG",
      "downloadPng": "Скачать PNG",
      "card": "Визитка",
      "downloadCard": "Скачать визитку для печати (PDF)",
      "linkCopied": "Ссылка скопирована",
      "linksCopied": "Ссылки скопированы: {{count}}",
      "imageCopied": "Картинка скопирована",
      "copyFailed": "Не удалось скопировать",
      "downloadFailed": "Не удалось скачать",
      "copyCode": "Копировать код",
      "codeCopied": "Код скопирован",
      "copy": "Копировать"
    },
    "bulk": {
      "selected": "Выбрано: {{count}}",
      "selectAll": "Выделить все",
      "clearSelection": "Снять выделение",
      "copyLinks": "Копировать ссылки",
      "downloadQr": "Скачать QR",
      "downloadingQr": "Готовим архив…",
      "downloadCards": "Визитки",
      "downloadingCards": "Готовим визитки…",
      "extend": "Продлить",
      "export": "Экспорт"
    },
    "extend": {
      "title": "Продлить промокоды ({{count}})",
      "expiresOn": "Действует до (МСК, включительно)",
      "hint": "Дата ставится всем выбранным; пусто — бессрочно. Истёкшие коды снова действуют.",
      "clear": "Убрать срок",
      "submit": "Применить",
      "cancel": "Отмена"
    },
    "panel": {
      "title": "Промокод",
      "close": "Закрыть",
      "qrAlt": "QR-код со ссылкой на промокод {{code}}",
      "amount": "Номинал",
      "redemptions": "Применений",
      "limitUnlimited": "без лимита",
      "limitCompanies": "{{count}} комп.",
      "expires": "Действует до",
      "openRedemptions": "Открыть применения",
      "link": "Ссылка для клиента",
      "params": "Параметры",
      "expiresOn": "Действует до, МСК",
      "commentPlaceholder": "для чего этот код",
      "createdBy": "Создал",
      "createdAt": "Создан",
      "pause": "Поставить на паузу",
      "cancel": "Отмена",
      "save": "Сохранить"
    },
    "dialog": {
      "createTitle": "Новый промокод",
      "kind": "Тип",
      "kindOpenHint": "Активирует любая компания, не больше одного раза. Лимит применений необязателен.",
      "kindClosedHint": "Только компании из списка, каждая по одному разу. Лимит равен списку.",
      "code": "Код",
      "codePlaceholder": "пусто — сгенерируем",
      "codeHint": "6–32 латинских буквы, цифры и дефис, без пробелов; регистр при вводе не важен. Код и номинал после создания не меняются.",
      "codeError": {
        "chars": "Только латинские буквы, цифры и дефис — без пробелов и кириллицы.",
        "short": "Код не короче 6 символов.",
        "long": "Код не длиннее 32 символов."
      },
      "amountRub": "Номинал (₽)",
      "companies": "Компании",
      "companiesPlaceholder": "Добавить компанию…",
      "companiesEmpty": "Добавьте хотя бы одну компанию.",
      "companyRedeemed": "Компания уже применила код — из списка её не убрать.",
      "removeCompany": "Убрать {{name}}",
      "maxRedemptions": "Лимит применений",
      "maxRedemptionsPlaceholder": "пусто — без лимита",
      "expiresOn": "Действует до (МСК, включительно)",
      "expiresOnPlaceholder": "бессрочно",
      "expiresOnClear": "Убрать срок",
      "comment": "Комментарий",
      "previewAmount": "Код зачислит {{amount}}",
      "previewOpenLimited": "открытый, лимит {{count}}",
      "previewOpenUnlimited": "открытый, без лимита",
      "previewClosed": "закрытый, компаний: {{count}}",
      "previewTill": "до {{date}}",
      "save": "Создать",
      "cancel": "Отмена"
    }
  },
  "spendLimits": {
    "title": "Лимиты расходов",
    "hint": "Считаем расход с 1-го числа вместе с генерациями, которые ещё идут. Когда лимит закончится, новые генерации не запускаются, а начатые доигрывают, поэтому итог может немного превысить лимит.",
    "description": "Генерация запускается, только если хватает каждого лимита — сотрудника, проекта и компании — и денег на счёте; начатые генерации доигрывают.",
    "selfNote": "Генерация запускается, если хватает каждого лимита. Начатые доигрывают. Поднять лимит может владелец компании.",
    "addLimit": "Добавить лимит",
    "addMenu": {
      "company": "Лимит компании",
      "memberDefault": "Сотрудникам по умолчанию",
      "member": "Сотруднику — в его карточке на «Сотрудниках»",
      "project": "Проекту — в настройках проекта"
    },
    "edit": "Изменить",
    "add": "Добавить",
    "remove": "Снять лимит",
    "cancel": "Отмена",
    "close": "Закрыть",
    "save": "Сохранить",
    "companyRule": "Компания",
    "memberDefaultRule": "Сотрудникам по умолчанию",
    "noLimit": "Без лимита",
    "spentPrefix": "потрачено",
    "spentShare": "потрачено {{percent}} лимита",
    "clickToEdit": "нажмите, чтобы изменить",
    "inProgressSuffix": ", из них {{amount}} в работе",
    "inProgressShort": "из них {{amount}} в работе",
    "leftPrefix": "осталось",
    "defaultRuleLine": "каждому, у кого нет своего лимита, включая владельцев · сейчас {{on}} из {{total}}",
    "nearLimit": "у предела:",
    "exceptionsTitle": "Исключения и проекты · {{count}}",
    "exceptionsNote": "остальные сотрудники — по умолчанию, у остальных проектов лимита нет",
    "exceptionsEmpty": "Исключений нет: все сотрудники — по умолчанию, у проектов лимита нет. Лимит сотруднику ставится в его карточке на «Сотрудниках», проекту — в настройках проекта.",
    "colWho": "Кому",
    "colLimit": "Лимит",
    "colSpent": "Потрачено",
    "colLeft": "Осталось",
    "tagDefault": "по умолчанию",
    "tagCustom": "индивидуальный",
    "tagUnlimited": "без лимита",
    "tagProject": "проект",
    "footHint": "Лимиты считаются за календарный месяц и обновляются 1-го числа в {{time}} (по вашему времени).",
    "offTitle": "Лимиты расходов работают в режимах «Наблюдение» и «Контроль»",
    "offBody": "Биллинг компании «{{company}}» в режиме «Выключен»: генерации не резервируют и не списывают средства, поэтому лимиты не действуют и поставить новый нельзя. Режим биллинга переключает супер-админ платформы. Поставленные раньше лимиты сохраняются и снова начнут действовать, когда режим вернут.",
    "overdraft": {
      "title": "Допустимый минус",
      "usedUp": "исчерпан",
      "description": "Насколько счёт может уйти в минус в режиме «Наблюдение», прежде чем новые генерации остановятся. Минус гасится пополнением баланса, размер задаёт Frameriver.",
      "edit": "Изменить минус",
      "unavailable": "Доступно только в режиме «Наблюдение».",
      "limit": "Лимит минуса",
      "limitSub": "размер задаёт Frameriver",
      "used": "Использовано",
      "usedSub": "из лимита минуса",
      "usedNone": "счёт в плюсе — минус не тронут",
      "usedStopped": "новые генерации остановлены — пополните баланс",
      "dialog": {
        "title": "Допустимый минус",
        "description": "Насколько счёт компании «{{name}}» может уйти в минус в режиме «Наблюдение». Клиент видит сумму, менять её может только супер-админ.",
        "amount": "Сумма",
        "hint": "Новые генерации остановятся, когда доступное на счёте списания опустится ниже −этой суммы. 0 — без минуса."
      }
    },
    "state": {
      "default": "По умолчанию",
      "custom": "Индивидуальный",
      "unlimited": "Без лимита"
    },
    "topupUntil": "+ {{amount}} до {{date}}",
    "tile": {
      "of": "из {{limit}}",
      "topup": "включая {{amount}} до конца месяца"
    },
    "resetsAt": "Обновится {{date}} в {{time}}",
    "resetsAtLower": "обновится {{date}} в {{time}}",
    "dialog": {
      "memberTitle": "Лимит расходов — {{name}}",
      "memberDescription": "Потолок трат за календарный месяц.",
      "defaultTitle": "Лимит расходов по умолчанию",
      "defaultDescription": "Сумма для всех, у кого выбрано «По умолчанию», — включая владельцев.",
      "projectTitle": "Лимит расходов проекта «{{name}}»",
      "projectDescription": "Сколько проект может потратить за календарный месяц — с какого бы счёта ни списывались деньги.",
      "companyTitle": "Лимит расходов компании",
      "companyDescription": "Потолок компании «{{name}}» за месяц — на все генерации сотрудников, владельцев и проектов.",
      "offDescription": "Потолок трат за календарный месяц.",
      "whichApplies": "Какой лимит действует",
      "segmentDefault": "По умолчанию",
      "segmentCustom": "Индивидуальный",
      "segmentUnlimited": "Без лимита",
      "defaultSub": "Действует лимит по умолчанию для сотрудников компании.",
      "customSub": "Индивидуальная сумма заменяет лимит по умолчанию.",
      "amount": "Сумма",
      "amountDefault": "Сумма · по умолчанию",
      "moreThanAmount": "больше суммы",
      "calcInMonthSpent": "В {{month}} потрачено",
      "calcOfWhich": "из них",
      "calcInProgress": "в работе",
      "calcWillRemain": "останется",
      "calcRemains": "осталось",
      "warnSpent": "В {{month}} уже потрачено {{spent}}{{inProgress}} — больше новой суммы.",
      "warnInProgress": " (из них {{amount}} в работе)",
      "warnMember": "После сохранения новые генерации этого сотрудника не запустятся до {{date}}, начатые доиграют.",
      "warnProject": "После сохранения новые генерации в проекте не запустятся до {{date}}, начатые доиграют.",
      "warnCompany": "После сохранения новые генерации в компании не запустятся до {{date}}, начатые доиграют.",
      "defaultNote": "Меняется сразу у всех, у кого «По умолчанию».",
      "defaultConfirmTitle": "Поменять лимит по умолчанию?",
      "defaultConfirm": "Сумма {{amount}} изменится у всех, кто на лимите «По умолчанию».",
      "unlimitedTitle": "Личного лимита нет",
      "unlimitedBody": "{{name}} тратит без личного лимита. Лимиты проектов и компании действуют и здесь.",
      "unlimitedBodyCompany": "{{name}} тратит без личного лимита. Лимиты проектов и компании действуют и здесь: по компании до {{date}} осталось {{left}} из {{limit}}.",
      "unlimitedOwners": "Лимит по умолчанию действует и на владельцев — поэтому «Без лимита» выбирается явно.",
      "appliesToPrefix": "Действует для",
      "appliesToCount": "{{on}} из {{total}}",
      "appliesToSuffix": "человек.",
      "atLimitList": "У предела · {{count}}",
      "atLimitAside": "80 % и больше",
      "customList": "Индивидуальный · {{count}}",
      "unlimitedList": "Без лимита · {{count}}",
      "projectNote": "Лимит и «Счёт для списаний» независимы: счёт — откуда берутся деньги, лимит — сколько проект может потратить за месяц с любого счёта. Генерации остановятся, когда кончится что-то одно.",
      "projectHidden": "Команда проекта сумм не видит — когда лимит закончится, получит отказ без цифр.",
      "companyHidden": "Сотрудники суммы не видят — когда лимит закончится, получат отказ без цифр.",
      "offBody": "Биллинг компании «{{company}}» в режиме «Выключен»: генерации не резервируют и не списывают средства, поэтому лимиты не действуют.",
      "offSaved": "Сохранённый лимит {{amount}} не удалён и снова начнёт действовать, когда режим вернут.",
      "offSavedUnlimited": "Сохранённое состояние «Без лимита» не удалено и снова начнёт действовать, когда режим вернут.",
      "offMode": "Режим биллинга переключает супер-админ платформы.",
      "changedBy": "Изменено {{date}} · {{name}}",
      "changed": "Изменено {{date}}",
      "topup": "Дополнительно в этом месяце",
      "topupHint": "Не меняет лимит. Действует до сброса, потом сгорает.",
      "topupCalc": "В {{month}} можно потратить {{total}} ({{base}} + {{extra}})."
    }
  },
  "projectBilling": {
    "headTitle": "Биллинг проекта",
    "title": "Биллинг",
    "spentTotal": "Всего потрачено",
    "inProgress": "В работе",
    "inProgressHint": "Заморожено под идущие генерации: спишется по факту, остаток вернётся на счёт",
    "account": "Счёт списания",
    "noAccount": "Счёта ещё нет",
    "accountOther": "Счёт в {{currency}}",
    "limit": "Лимит проекта",
    "noLimit": "Без лимита",
    "limitUsed": "{{spent}} из {{amount}} в этом месяце",
    "limitSetup": "Настроить",
    "platformDashboard": "Платформа",
    "historyCurrencyNote": "История проекта в {{currency}} — до перевода проекта в {{projectCurrency}}. Лимит и счёт списания действуют в {{projectCurrency}}.",
    "byModels": "По моделям",
    "discount": "Скидка проекта {{percent}}%",
    "byJobKinds": "По видам генераций"
  },
  "proposals": {
    "title": "Коммерческие предложения",
    "new": "Новое КП",
    "create": "Создать",
    "createTitle": "Новое КП",
    "cancel": "Отмена",
    "save": "Сохранить",
    "delete": "Удалить",
    "downloadPdf": "Скачать PDF",
    "deleteConfirm": "Удалить КП {{number}}? Номер не освободится.",
    "unsaved": "Есть несохранённые изменения",
    "author": "Автор: {{name}}",
    "empty": "Коммерческих предложений пока нет",
    "allStatuses": "Все статусы",
    "searchPlaceholder": "Номер, клиент или ИНН",
    "withoutRequisites": "без реквизитов",
    "inn": "ИНН {{inn}}",
    "companySearch": "Поиск компании",
    "companyPlaceholder": "Выберите компанию",
    "requisites": "В КП: {{name}}, ИНН {{inn}}.",
    "noRequisites": "Реквизитов нет — в КП будет только название компании.",
    "addresseePlaceholder": "Генеральному директору Иванову И. И.",
    "depositCreditPlaceholder": "Если больше пополнения — бонус",
    "termsNotePlaceholder": "Персональный менеджер, обучение команды, поддержка…",
    "preview": "Превью КП",
    "previewLoading": "Готовим превью…",
    "previewFailed": "Превью не собралось: {{message}}",
    "status": {
      "draft": "Черновик",
      "sent": "Отправлено",
      "accepted": "Принято",
      "rejected": "Отклонено",
      "expired": "Истекло"
    },
    "columns": {
      "number": "Номер",
      "company": "Клиент",
      "issuedOn": "Дата",
      "validUntil": "Действует до",
      "seats": "Мест",
      "deposit": "Пополнение",
      "discount": "Скидка",
      "status": "Статус",
      "author": "Автор"
    },
    "sections": {
      "client": "Клиент",
      "document": "Документ",
      "features": "Возможности платформы",
      "terms": "Условия",
      "appendix": "Приложения и подпись",
      "examples": "Ориентиры стоимости"
    },
    "fields": {
      "company": "Компания",
      "priceList": "Прайс-лист",
      "addressee": "Адресат",
      "issuedOn": "Дата КП",
      "validUntil": "Действует до",
      "seats": "Рабочих мест",
      "discount": "Скидка, %",
      "discountMonths": "Срок скидки, мес.",
      "deposit": "Первое пополнение, {{currency}}",
      "depositCredit": "Зачисляется на баланс, {{currency}}",
      "models": "Модели",
      "termsNote": "Дополнительные условия",
      "includePriceList": "Прайс-лист приложением",
      "committedMinutes": "Коммит, минут генерации",
      "showContact": "Контактное лицо",
      "contactName": "Имя",
      "contactEmail": "Email"
    },
    "plans": {
      "apply": "Подставить из тарифного плана",
      "discount": "{{name}} — скидка {{percent}}% на {{months}} мес.",
      "deposit": "{{name}} — платёж {{price}}, на баланс {{credit}}"
    },
    "models": {
      "title": "Модели в КП",
      "apply": "Применить",
      "choose": "Выбрать",
      "all": "Все модели прайс-листа ({{count}})",
      "selected": "Выбрано {{count}} из {{total}}"
    },
    "features": {
      "open": "Тексты блоков",
      "title": "Блоки «Возможности платформы»",
      "description": "Порядок здесь — порядок в КП. Выключенный блок не предлагается в новых КП.",
      "add": "Добавить блок",
      "active": "Предлагать в новых КП",
      "titlePlaceholder": "Название блока",
      "bodyPlaceholder": "Описание, 1–2 предложения",
      "moveUp": "Выше",
      "moveDown": "Ниже",
      "remove": "Удалить блок"
    },
    "examples": {
      "choose": "Выбрать строки",
      "title": "Ориентиры стоимости",
      "selected": "Выбрано: {{count}}",
      "empty": "Блок не попадёт в КП.",
      "missing": "нет ставки в этом прайс-листе, в КП не попадёт",
      "audio": "со звуком",
      "single": "единая цена"
    },
    "committedMinutesPlaceholder": "Без коммита",
    "committedMinutesHint": "Условия действуют при обязательстве на этот объём видео; в КП — приписка, что при большем объёме условия могут быть улучшены."
  },
  "spendReports": {
    "title": "Сводки расходов",
    "new": "Новая сводка",
    "searchPlaceholder": "Номер, название или компания",
    "empty": "Сводок пока нет. Новая сводка создаётся за прошлый месяц.",
    "platformWide": "Вся платформа",
    "columns": {
      "number": "Номер",
      "title": "Название",
      "scope": "Охват",
      "period": "Период",
      "author": "Автор",
      "updated": "Изменена"
    },
    "createTitle": "Новая сводка расходов",
    "createHint": "Черновик создаётся за прошлый месяц; период, проекты и разделы меняются в редакторе.",
    "create": "Создать",
    "cancel": "Отмена",
    "sections": {
      "scope": "Охват",
      "period": "Период",
      "sections": "Разделы",
      "detail": "Детализация",
      "design": "Оформление"
    },
    "fields": {
      "company": "Компания",
      "projects": "Проекты",
      "from": "С",
      "to": "По",
      "compare": "Сравнение",
      "currency": "Валюта",
      "topN": "Строк в таблицах",
      "grouping": "Динамика",
      "title": "Заголовок",
      "comment": "Комментарий на первой странице"
    },
    "titlePlaceholder": "Сводка расходов",
    "commentPlaceholder": "Например: рост за счёт съёмок нового ролика",
    "compare": {
      "previous": "С прошлым периодом",
      "none": "Без сравнения"
    },
    "topAll": "Все",
    "topHint": "Остальные строки сворачиваются в «Ещё N …», итоги не меняются.",
    "grouping": {
      "day": "Дни",
      "week": "Недели",
      "month": "Месяцы"
    },
    "presets": {
      "prevMonth": "Прошлый месяц",
      "thisMonth": "Этот месяц",
      "prevQuarter": "Прошлый квартал",
      "ytd": "С начала года"
    },
    "projects": {
      "all": "Все проекты · {{count}}",
      "selected": "{{count}} из {{total}}",
      "choose": "Выбрать",
      "title": "Проекты в сводке",
      "apply": "Применить",
      "selectAll": "Выбрать все",
      "clearAll": "Снять все",
      "search": "Поиск проекта",
      "empty": "Проектов нет",
      "platformHint": "Проекты выбираются у сводки по одной компании."
    },
    "sectionLabels": {
      "summary": "Итоги периода",
      "facts": "Главное за период",
      "kinds": "Структура по видам генераций",
      "daily": "Динамика расходов",
      "companies": "Компании",
      "projects": "Проекты",
      "models": "Модели",
      "models_chart": "График «расходы против количества»",
      "users": "Сотрудники",
      "project_kinds": "Проекты × виды генераций",
      "users_projects": "Сотрудники × проекты",
      "method": "Как считается"
    },
    "flags": {
      "show_emails": "Email сотрудников",
      "show_providers": "Провайдеры моделей",
      "show_errors": "Доля ошибок генерации",
      "show_contact": "Контакт менеджера (автор сводки)"
    },
    "save": "Сохранить",
    "delete": "Удалить",
    "deleteConfirm": "Удалить сводку {{number}}?",
    "unsaved": "Есть несохранённые изменения",
    "author": "Автор: {{name}}",
    "downloadPdf": "Скачать PDF",
    "preview": "Превью сводки",
    "previewLoading": "Собираем PDF…",
    "previewFailed": "Не удалось собрать превью: {{message}}"
  }
}
